import { useEffect } from 'react'

import { useAppContext } from '@/App.context'
import skytechFavicon from '@/assets/favicons/skytech/favicon-orange.png'
import arpFavicon from '@/assets/gfx/favicons/arp-favicon.png'
import bechtleFavicon from '@/assets/gfx/favicons/bechtle-favicon.ico'
import csiFavicon from '@/assets/gfx/favicons/csi-favicon.ico'
import elkjopFavicon from '@/assets/gfx/favicons/elkjop-favicon.png'
import mobitLogo from '@/assets/gfx/favicons/mobit-favicon.png'
import arpLogo from '@/assets/gfx/logos/logo-arp.png'
import bechtleLogo from '@/assets/gfx/logos/logo-bechtle.png'
import csiLogo from '@/assets/gfx/logos/logo-csi.png'
import elkjopLogo from '@/assets/gfx/logos/logo-elkjop.svg'
import skytechLogo from '@/assets/logos/skytech/logo-orange.png'

const useMetaTags = () => {
  const { whiteLabel } = useAppContext()
  // @ts-ignore
  const setDocFavicon = file => {
    const favicon = document.querySelector("link[rel*='icon']")
    // @ts-ignore
    favicon.href = file
  }
  // @ts-ignore
  const setLogo = file => {
    const favicon = document.querySelector("link[rel*='apple-touch-icon']")
    // @ts-ignore
    favicon.href = file
  }
  // @ts-ignore
  const setDocTitle = title => {
    document.title = title
  }

  useEffect(() => {
    const refreshMeta = () => {
      switch (whiteLabel) {
        case 'mobit':
          setDocFavicon(mobitLogo)
          setLogo(mobitLogo)
          setDocTitle('Mobit Dealer')
          break
        case 'elkjop':
          setDocFavicon(elkjopFavicon)
          setLogo(elkjopLogo)
          setDocTitle('Elkjøp Dealer')
          break
        case 'bechtle':
          setDocFavicon(bechtleFavicon)
          setLogo(bechtleLogo)
          setDocTitle('Bechtle Dealer')
          break
        case 'arp':
          setDocFavicon(arpFavicon)
          setLogo(arpLogo)
          setDocTitle('ARP Dealer')
          break
        case 'csi':
          setDocFavicon(csiFavicon)
          setLogo(csiLogo)
          setDocTitle('CSI Dealer')
          break
        default:
          setDocFavicon(skytechFavicon)
          setLogo(skytechLogo)
          setDocTitle('Skytech Control Dealer')
      }
    }
    refreshMeta()
  }, [whiteLabel])
}

export default useMetaTags
